import type { WABA } from '@/services/whatsappService'

/**
 * Prefer the WABA from the active WhatsApp channel connection so template lists
 * match what embedded signup can send from.
 */
export function resolvePreferredWhatsAppWabaId(
  wabas: WABA[],
  connectedAccountId?: string | null,
): string {
  const connected = connectedAccountId?.trim()
  if (connected && wabas.some((waba) => waba.id === connected)) {
    return connected
  }
  return wabas[0]?.id?.trim() || ''
}
